module.exports = __webpack_public_path__ + "static/media/SRRC.efef898f.PNG";